import type { DashboardFilters } from "@/Pages/Cases/filtering/DashboardFilters";
import type { Filter, InFilter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { CaseFilterGroup } from "@/Pages/Cases/filtering/CaseFilterGroup";

export const dashboardFiltersToFilters = (filters: DashboardFilters): Filter[] => {
  return [
    { fieldName: "emsAgency.id", values: filters?.ems ?? [] } as InFilter,
    { fieldName: "destinationHospital.id", values: filters?.hospitals ?? [] } as InFilter,
    { fieldName: "complaint.id", values: filters?.complaints ?? [] } as InFilter,
  ]
    .filter((filter) => filter.values.length > 0)
    .map((filter) => ({ ...filter, group: CaseFilterGroup.main }));
};
